import { render, staticRenderFns } from "./reviewTaskManage.vue?vue&type=template&id=54793360&scoped=true&"
import script from "./reviewTaskManage.vue?vue&type=script&lang=js&"
export * from "./reviewTaskManage.vue?vue&type=script&lang=js&"
import style0 from "./reviewTaskManage.vue?vue&type=style&index=0&id=54793360&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54793360",
  null
  
)

export default component.exports